<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

import UIcon from 'src/components/ui/UIcon.vue'

const props = defineProps({
  target: {
    type: String,
    default: 'window',
    validator(value) {
      return ['window', 'parent'].includes(value)
    },
  },
  threshold: {
    type: Number,
    default: 400,
  },
})

const el = ref()

const isVisible = ref(false)
const checkVisibility = (scrollY) => {
  isVisible.value = scrollY > props.threshold
}

const scrollListener = ref()
const bindParentScrollListener = () => {
  scrollListener.value = () => {
    checkVisibility(el.value.parentElement.scrollTop)
  }

  el.value.parentElement.addEventListener('scroll', scrollListener.value)
}
const bindDocumentScrollListener = () => {
  scrollListener.value = () => {
    checkVisibility(window.scrollY)
  }

  window.addEventListener('scroll', scrollListener.value)
}
onMounted(() => {
  if (props.target === 'window') {
    bindDocumentScrollListener()
  } else if (props.target === 'parent') {
    bindParentScrollListener()
  }
})
const unbindParentScrollListener = () => {
  if (scrollListener.value) {
    el.value?.parentElement.removeEventListener('scroll', scrollListener.value)
    scrollListener.value = null
  }
}
const unbindDocumentScrollListener = () => {
  if (scrollListener.value) {
    window.removeEventListener('scroll', scrollListener.value)
    scrollListener.value = null
  }
}
onBeforeUnmount(() => {
  if (props.target === 'window') {
    unbindDocumentScrollListener()
  } else if (props.target === 'parent') {
    unbindParentScrollListener()
  }
})

const scrollToTop = () => {
  const scrollElement = props.target === 'window' ? window : el.value.parentElement
  scrollElement.scroll({
    top: 0,
    behavior: 'smooth',
  })
}
</script>

<template>
  <Transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div
      v-if="isVisible"
      ref="el"
      class="tw-fixed tw-bottom-6 tw-right-layout-x tw-z-10 tw-flex tw-size-14 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-bg-white-v2 tw-shadow-2xl hover:tw-text-primary -md:tw-size-10"
      @click="scrollToTop"
    >
      <UIcon name="arrow-up" class="tw-animate-bounce tw-text-[1.25rem] -md:tw-text-[0.875rem]" />
    </div>
  </Transition>
</template>
